const minimize = (string) => (string || '').trim().replace(/\s+/g, '')

export default minimize